import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROLE_ROUTES } from '../utils/constants';

const RoleBasedRoute = ({ children, allowedRoles, requiredModule }) => {
  const { user, loading, hasModuleAccess } = useAuth();

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={ROLE_ROUTES[user.role] || '/login'} replace />;
  }

  // Module-level access check for staff users
  if (requiredModule && user.role === 'staff' && !hasModuleAccess(requiredModule)) {
    // Staff with no modules at all → redirect to no-permission home
    const modules = user.accessModules || user.access_modules;
    if (!modules || !Array.isArray(modules) || modules.length === 0) {
      return <Navigate to="/staff/home" replace />;
    }

    // Staff has some modules but not this one → redirect to home
    return <Navigate to="/staff/home" replace />;
  }

  return children;
};

export default RoleBasedRoute;
